<template>
	<div class="modal" id="edit-company-user-modal" tabindex="-1" role="dialog" aria-labelledby="vsofModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Edit {{ fullname }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<form @submit.prevent="updateUser">
						<div class="nav-wrapper tx-13">
							<nav class="nav nav-line tx-medium" id="editClientNav">
								<a href="#edit-bio-data" class="nav-link active" data-toggle="tab">Bio Data</a>
								<a href="#edit-identification-information" class="nav-link" data-toggle="tab">Identification Information</a>
							</nav>
						</div>
						<div class="tab-content pt-3">
							<div id="edit-bio-data" class="tab-pane fade active show">
								<div class="row">
									<div class="form-group col-md-6">
										<label>First Name</label>
										<input
											v-model="form.first_name"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('first_name') }"
											placeholder="Enter first name"
										/>
										<has-error :form="form" field="first_name"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Last Name</label>
										<input
											v-model="form.last_name"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('last_name') }"
											placeholder="Enter last name"
										/>
										<has-error :form="form" field="last_name"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Other Names</label>
										<input
											v-model="form.additional_names"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('additional_names') }"
											placeholder="Enter other names"
										/>
										<has-error :form="form" field="additional_names"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Email Address</label>
										<input v-model="form.email" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('email') }" placeholder="Enter other names" />
										<has-error :form="form" field="email"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Phone</label>
										<phone-number-component
											:has-error="form.errors.has('phone')"
											:country="form.country"
											:phone-number="form.phone"
											@update-phone-country="updatePhoneCountry"
											@update-phone="updatePhone"
										/>
									</div>
									<div class="form-group col-md-6">
										<label>Residential Address</label>
										<input
											v-model="form.address_line_1"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('address_line_1') }"
											placeholder="Enter residential address"
										/>
										<has-error :form="form" field="address_line_1"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Digital Address</label>
										<input
											v-model="form.address_line_2"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('address_line_2') }"
											placeholder="Enter digital address"
										/>
										<has-error :form="form" field="address_line_2"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Postal Address</label>
										<input
											v-model="form.address_line_3"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('address_line_3') }"
											placeholder="Enter postal address"
										/>
										<has-error :form="form" field="address_line_3"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Job Title</label>
										<input
											v-model="form.position"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('position') }"
											placeholder="Enter job title"
										/>
										<has-error :form="form" field="position"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>designation</label>
										<select v-model="form.designation" class="form-control custom-select shadow-sm text-capitalize" :class="{ 'is-invalid': form.errors.has('designation') }">
											<option selected :value="null" disabled>Select an option</option>
											<option v-for="(option, index) in designationOptions" :value="option" :key="index">{{ option }}</option>
										</select>
										<has-error :form="form" field="designation"></has-error>
									</div>
								</div>
							</div>
							<div id="edit-identification-information" class="tab-pane fade">
								<div class="row">
									<div class="form-group col-md-6">
										<label>Identification Type</label>
										<select
											v-model="form.identification_document_type"
											class="form-control custom-select shadow-sm"
											:class="{ 'is-invalid': form.errors.has('identification_document_type') }"
										>
											<option selected :value="null" disabled>Select an option</option>
											<option v-for="(option, index) in identificationTypes" :value="option" :key="index">{{ option }}</option>
										</select>
										<has-error :form="form" field="identification_document_type"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>ID Number</label>
										<input
											v-model="form.identification_document_number"
											type="text"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('identification_document_number') }"
											placeholder="Enter ID number"
										/>
										<has-error :form="form" field="identification_document_number"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Expiry Date</label>
										<input
											v-model="form.identification_document_expiry_date"
											type="date"
											class="form-control shadow-sm"
											:class="{ 'is-invalid': form.errors.has('identification_document_expiry_date') }"
											placeholder="Enter expiry date"
										/>
										<has-error :form="form" field="identification_document_expiry_date"></has-error>
									</div>
									<div class="form-group col-md-6">
										<label>Country of Issuance</label>
										<select
											v-model="form.identification_document_country"
											class="form-control custom-select shadow-sm"
											:class="{ 'is-invalid': form.errors.has('identification_document_country') }"
										>
											<option selected :value="null" disabled>Select an option</option>
											<option v-for="option in countries" :value="option.name" :key="option.id">{{ option.name }}</option>
										</select>
										<has-error :form="form" field="identification_document_country"></has-error>
									</div>
								</div>
							</div>
						</div>

						<button-component :busy="form.busy" label="Update" label-loading="Updating user..." button-class="btn btn-block btn-default" :aria-busy="form.busy" />
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		const designationOptions = ['approver', 'inputter'];

		return {
			designationOptions,
			fullname: null,
			form: new Form({
				first_name: null,
				last_name: null,
				additional_names: null,
				email: null,
				phone: null,
				identification_document_type: null,
				identification_document_number: null,
				identification_document_expiry_date: null,
				identification_document_country: null,
				address_line_1: null,
				address_line_2: null,
				address_line_3: null,
				position: null,
				designation: null,
				country: null,
			}),
		};
	},
	watch: {
		'user.id': function (value) {
			if (value) {
				this.fullname = this.user.fullname

				const {
					first_name,
					last_name,
					additional_names,
					email,
					phone,
					identification_document_type,
					identification_document_number,
					identification_document_expiry_date,
					identification_document_country,
					address_line_1,
					address_line_2,
					address_line_3,
					position,
					designation,
					country,
				} = this.user;

				this.form.fill({
					first_name,
					last_name,
					additional_names,
					email,
					phone,
					identification_document_type,
					identification_document_number,
					identification_document_expiry_date,
					identification_document_country,
					address_line_1,
					address_line_2,
					address_line_3,
					position,
					designation,
					country,
				});
			}
		},
	},
	computed: {
		...mapGetters({
			countries: 'countries',
			identificationTypes: 'identificationTypes',
		}),
	},
	methods: {
		updateUser() {
			this.form
				.put(`/api/company-users/${this.user.id}`)
				.then(() => {
					this.$emit('refresh');
					$('edit-company-user-modal').modal('hide');
				})
				.catch(({ response }) => console.log(response));
		},
		updatePhoneCountry(value) {
			this.form.country = value;
		},
		updatePhone(phone) {
			this.form.phone = phone;
		},
	},
	props: {
		user: {
			type: Object,
			required: false,
		},
	},
};
</script>
